import { type FC, useMemo } from 'react';
import type { TimestampProps } from './Timestamp.types';
import { getDateAgo } from '@/_utils/dates';

export const Timestamp: FC<TimestampProps> = ({
  timestamp,
  hideTime,
  isFromNow,
}) => {
  const formatDate: string = useMemo(() => {
    if (!timestamp) return '';

    const date: Date = new Date(timestamp);

    if (isFromNow) {
      return getDateAgo(timestamp);
    }

    const dateString = date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });

    if (hideTime) {
      return dateString;
    }

    const timeString = date.toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    return `${dateString} at ${timeString}`;
  }, [hideTime, isFromNow, timestamp]);

  if (!timestamp) return null;

  return <>{formatDate}</>;
};
